import clsx from "clsx";
import { memo } from "react";
import * as Flex from "@repo/ui/flex";
import { TYPOGRAPHY_HEADING1 } from "@/theme/topshop-2/typography/typography-constants";
import styles from "./video-overlay.module.css";

interface VideoControlsProps {
  onSkip: (e: React.MouseEvent) => void;
}

const VideoControls = memo<VideoControlsProps>(({ onSkip }) => (
  <Flex.Item className={styles.videoTextContainer}>
    <button
      onClick={onSkip}
      className={clsx(TYPOGRAPHY_HEADING1, styles.videoButton)}
      aria-label="Skip video"
    >
      Skip Video
    </button>
  </Flex.Item>
));

VideoControls.displayName = "VideoControls";

export default VideoControls;
